import 'core-js/stable';
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './plugins/toasted';
import './plugins/vueNotifications';
import './plugins/mobileDetectorMixin';
import vpShow from './utils/vpshowDirective.js';
import axios from "axios";
import '@/styles/index.scss'

axios.defaults.baseURL = 'https://legitdoc.com/api';
Vue.config.productionTip = false;
Vue.directive('vp-show', vpShow);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
